<section class="opendelivery-integracoes integration-page">
  <div class="alert alert-success" role="status" *ngIf="mensagemLista">
    <i class="fas fa-check-circle mr-2"></i>{{mensagemLista}}
  </div>
  <div class="alert alert-danger" role="alert" *ngIf="erroLista">
    <i class="fas fa-exclamation-triangle mr-2"></i>{{erroLista}}
  </div>
  <div class="alert alert-danger" role="alert" *ngIf="erro && modoTela !== 'formulario'">
    <i class="fas fa-exclamation-triangle mr-2"></i>{{erro}}
  </div>

  <header class="page-header">
    <div>
      <h2>{{modoTela === 'listagem' ? 'Integrações OpenDelivery' :
        modoTela === 'escolha' ? 'Adicionar integração OpenDelivery' :
        (integracao.id ? 'Editar integração OpenDelivery' : 'Configurar integração OpenDelivery')}}</h2>
      <p *ngIf="modoTela === 'listagem'">Gerencie as plataformas que enviam pedidos para esta loja.</p>
      <p *ngIf="modoTela === 'escolha'">Escolha como a nova plataforma será conectada.</p>
      <p *ngIf="modoTela === 'formulario'">Configure a autenticação e o recebimento de pedidos desta conexão.</p>
    </div>
    <div class="header-actions" *ngIf="modoTela === 'listagem'">
      <button type="button" class="btn btn-primary" [disabled]="processando" (click)="novaIntegracao()">
        <i class="k-icon k-i-plus mr-1"></i>Adicionar nova integração
      </button>
    </div>
  </header>

  <ng-container *ngIf="modoTela === 'listagem'">
    <div class="summary-grid">
      <article class="summary-card">
        <span class="summary-icon"><i class="fas fa-link"></i></span>
        <div><small>Integrações cadastradas</small><strong>{{integracoes.length}}</strong></div>
      </article>
      <article class="summary-card order">
        <span class="summary-icon"><i class="fas fa-check-circle"></i></span>
        <div><small>Integrações ativas</small><strong>{{quantidadeAtivas}}</strong></div>
      </article>
      <article class="summary-card">
        <span class="summary-icon"><i class="fas fa-bell"></i></span>
        <div><small>Recebendo por webhook</small><strong>{{quantidadeWebhook}}</strong></div>
      </article>
      <article class="summary-card shipping">
        <span class="summary-icon"><i class="fas fa-sync-alt"></i></span>
        <div><small>Recebendo por polling</small><strong>{{quantidadePolling}}</strong></div>
      </article>
    </div>

    <div class="integration-list">
      <div class="empty-state" *ngIf="!integracoes.length">
        <span class="empty-icon"><i class="fas fa-link"></i></span>
        <h4>Nenhuma integração OpenDelivery cadastrada</h4>
        <p>Adicione uma plataforma para começar a receber pedidos.</p>
        <button class="btn btn-primary" type="button" (click)="novaIntegracao()">
          <i class="k-icon k-i-plus mr-1"></i>Adicionar integração
        </button>
      </div>

      <article class="integration-card" *ngFor="let item of integracoes">
        <div class="integration-main">
          <div class="brand-column">
            <img *ngIf="item.modoConfiguracao === 'aiqfome'" src="/assets/icons/logo-aiqfome.png" alt="aiqfome">
            <span class="opendelivery-logo" *ngIf="item.modoConfiguracao !== 'aiqfome'">
              <i class="fas fa-code"></i><strong>OpenDelivery</strong>
            </span>
            <span class="status-pill" [class.disabled]="!item.ativa">
              <i class="fas fa-circle"></i>{{item.ativa ? 'Ativa' : 'Inativa'}}
            </span>
          </div>

          <div class="details-column">
            <div class="detail-row">
              <span><i class="fas fa-building"></i>Parceiro</span>
              <strong>{{nomeParceiro(item)}}</strong>
            </div>
            <div class="detail-row">
              <span><i class="fas fa-store"></i>Loja</span>
              <strong>{{item.nomeLojaExterna || 'Loja ainda não vinculada'}}</strong>
            </div>
            <div class="detail-row">
              <span><i class="fas fa-fingerprint"></i>ID externo</span>
              <strong class="merchant-id">{{item.orderingAppMerchantId || '—'}}</strong>
            </div>
            <div class="detail-row">
              <span><i class="far fa-calendar-alt"></i>Desde</span>
              <strong>{{item.dataAtivacao ? (item.dataAtivacao | date:'dd/MM/yyyy') : '—'}}</strong>
            </div>
          </div>

          <div class="api-column">
            <div class="api-status" [class.enabled]="item.ativa">
              <span class="api-icon"><i class="fas fa-shopping-cart"></i></span>
              <div><strong>Recebimento de pedidos</strong><small>{{item.ativa ? 'Habilitado' : 'Desabilitado'}}</small></div>
            </div>
            <div class="api-status" [class.enabled]="item.urlWebhookOnboarding || item.pollingAtivo">
              <span class="api-icon"><i class="fas" [ngClass]="item.urlWebhookOnboarding ? 'fa-bell' : 'fa-sync-alt'"></i></span>
              <div><strong>Forma de recebimento</strong><small>{{formaRecebimento(item)}}</small></div>
            </div>
            <div class="api-status" [class.enabled]="item.modoConfiguracao !== 'aiqfome' || item.onboardingConcluido">
              <span class="api-icon"><i class="fas fa-shield-alt"></i></span>
              <div><strong>Conexão</strong><small>{{item.modoConfiguracao === 'aiqfome' ?
                (item.onboardingConcluido ? 'Autorizada' : 'Aguardando autorização') : nomeAutenticacao(item)}}</small></div>
            </div>
          </div>
        </div>

        <footer class="integration-footer">
          <div class="footer-status">
            <span class="footer-shield"><i class="fas fa-shield-alt"></i></span>
            <div><small>Status da integração</small><strong [class.text-muted]="!item.ativa">{{item.ativa ? 'Ativa' : 'Inativa'}}</strong></div>
          </div>
          <div class="card-actions">
            <button class="btn btn-outline-primary" type="button" (click)="selecioneIntegracao(item)"
                    [disabled]="processandoIntegracaoId != null">
              <i class="fas fa-pencil-alt mr-1"></i>Editar
            </button>
            <button class="btn btn-outline-success" type="button" *ngIf="!item.ativa"
                    (click)="alterarAtivacaoDaLista(item, true)" [disabled]="processandoIntegracaoId != null">
              <i class="fas mr-1" [ngClass]="processandoIntegracaoId === item.id ? 'fa-spinner fa-spin' : 'fa-play-circle'"></i>Ativar
            </button>
            <button class="btn btn-outline-warning" type="button" *ngIf="item.ativa"
                    (click)="alterarAtivacaoDaLista(item, false)" [disabled]="processandoIntegracaoId != null">
              <i class="fas mr-1" [ngClass]="processandoIntegracaoId === item.id ? 'fa-spinner fa-spin' : 'fa-pause-circle'"></i>Desativar
            </button>
          </div>
        </footer>
      </article>
    </div>

    <aside class="api-help">
      <h4><i class="fas fa-info-circle mr-2"></i>Sobre as conexões</h4>
      <div class="help-item">
        <span><i class="fas fa-store"></i></span>
        <div><strong>Uma conexão por plataforma</strong><p>Cadastre aiqfome e outros parceiros OpenDelivery separadamente para acompanhar cada operação.</p></div>
      </div>
      <div class="help-item order">
        <span><i class="fas fa-bell"></i></span>
        <div><strong>Webhook</strong><p>O parceiro avisa imediatamente quando existe um novo evento de pedido.</p></div>
      </div>
      <div class="help-item shipping">
        <span><i class="fas fa-sync-alt"></i></span>
        <div><strong>Polling</strong><p>Use quando a plataforma não oferece webhook e os eventos precisam ser consultados periodicamente.</p></div>
      </div>
    </aside>
  </ng-container>

  <ng-container *ngIf="modoTela === 'escolha'">
    <button class="back-button" type="button" *ngIf="integracoes.length" (click)="exibaListagem()">
      <i class="fas fa-arrow-left mr-2"></i>Voltar para integrações
    </button>
    <div class="escolha-integracao">
      <button type="button" class="escolha-card aiqfome" (click)="selecioneModoNovaIntegracao('aiqfome')">
        <span class="escolha-logo"><img src="/assets/icons/logo-aiqfome.png" alt="aiqfome"></span>
        <span class="escolha-conteudo">
          <strong>Conectar com aiqfome</strong>
          <small>Autorize a loja com o ID Magalu. As credenciais e os endereços da plataforma já são administrados pelo Meu Cardápio.</small>
          <span class="escolha-acao">Selecionar <i class="fas fa-arrow-right ml-1"></i></span>
        </span>
      </button>
      <button type="button" class="escolha-card" (click)="selecioneModoNovaIntegracao('manual')">
        <span class="escolha-logo manual"><i class="fas fa-code"></i></span>
        <span class="escolha-conteudo">
          <strong>OpenDelivery manual</strong>
          <small>Configure outra plataforma compatível informando URLs, App ID e a forma de autenticação fornecida pelo parceiro.</small>
          <span class="escolha-acao">Selecionar <i class="fas fa-arrow-right ml-1"></i></span>
        </span>
      </button>
    </div>
  </ng-container>

  <ng-container *ngIf="modoTela === 'formulario'">
    <button class="back-button" type="button" (click)="integracoes.length ? exibaListagem() : novaIntegracao()">
      <i class="fas fa-arrow-left mr-2"></i>{{integracoes.length ? 'Voltar para integrações' : 'Escolher outra conexão'}}
    </button>

  <form class="integration-form" [ngClass]="{'needs-validation': !frm.submitted, 'was-validated': frm.submitted}"
        novalidate #frm="ngForm" (ngSubmit)="salvar()">

    <div class="form-context-header">
      <div>
        <span class="badge-aiqfome" *ngIf="integracao.modoConfiguracao === 'aiqfome'">aiqfome</span>
        <strong *ngIf="integracao.modoConfiguracao !== 'aiqfome'"><i class="fas fa-code mr-2"></i>OpenDelivery manual</strong>
        <small>{{integracao.nomeLojaExterna || (integracao.id ? 'Loja ainda não vinculada' : 'Nova conexão')}}</small>
      </div>
      <span class="status-pill" [class.disabled]="!integracao.ativa">
        <i class="fas mr-1" [ngClass]="integracao.ativa ? 'fa-check-circle' : 'fa-pause-circle'"></i>
        {{integracao.ativa ? 'Ativa' : 'Inativa'}}
      </span>
    </div>

    <div class="alert alert-success" *ngIf="mensagem" role="alert">
      <i class="fas fa-check-circle mr-2"></i>{{mensagem}}
    </div>
    <div class="alert alert-danger" *ngIf="erro && !conexaoAiqfomePendente" role="alert">
      <i class="fas fa-exclamation-triangle mr-2"></i>{{erro}}
    </div>

    <div class="card mb-4" [class.conexao-aiqfome-pendente]="conexaoAiqfomePendente"
         *ngIf="integracao.modoConfiguracao === 'aiqfome'">
      <div class="card-header">
        <h4 class="mb-0" *ngIf="integracao.onboardingConcluido; else tituloConectarAiqfome">
          <span class="badge-aiqfome mr-2">aiqfome</span>conectado
        </h4>
        <ng-template #tituloConectarAiqfome><h4 class="mb-0">Conectar com aiqfome</h4></ng-template>
      </div>
      <div class="card-body">
        <p *ngIf="integracao.nomeLojaExterna"><strong>{{integracao.nomeLojaExterna}}</strong>
          — Loja aiqfome {{integracao.orderingAppMerchantId}}</p>

        <ng-container *ngIf="conexaoAiqfomePendente; else conexaoAiqfomeDisponivel">
          <div class="alert alert-danger conexao-pendente-alerta mb-4" role="alert">
            <h5 class="alert-heading font-weight-bold">
              <i class="fas fa-exclamation-triangle mr-2"></i>Conexão com o aiqfome incompleta
            </h5>
            <p class="mb-2">
              A autorização foi recebida, mas a configuração da loja ainda não terminou.
              <strong>Você precisa concluir esta etapa para continuar e receber pedidos.</strong>
            </p>
            <p class="mb-0" *ngIf="integracao.ultimoErro">
              <strong>Motivo da falha:</strong> {{integracao.ultimoErro}}
            </p>
          </div>

          <button type="button" class="btn btn-danger btn-lg font-weight-bold"
                  [disabled]="processando" (click)="concluirAiqfome()">
            <i class="fas fa-redo mr-2"></i>Tentar concluir conexão
            <i class="k-i-loading k-icon ml-2" *ngIf="processando"></i>
          </button>
          <small class="d-block text-danger font-weight-bold mt-2">
            As demais configurações ficam bloqueadas até esta etapa ser concluída.
          </small>
          <div class="alert alert-danger mt-3 mb-0" *ngIf="erro" role="alert">
            <i class="fas fa-exclamation-triangle mr-2"></i>{{erro}}
          </div>
        </ng-container>

        <ng-template #conexaoAiqfomeDisponivel>
          <ng-container *ngIf="integracao.onboardingConcluido; else aguardandoConexaoAiqfome">
            <div class="alert mb-3" [ngClass]="integracao.ativa ? 'alert-success' : 'alert-warning'" role="status">
              <h5 class="alert-heading font-weight-bold">
                <i class="fas mr-2" [ngClass]="integracao.ativa ? 'fa-check-circle' : 'fa-pause-circle'"></i>
                Conexão concluída
              </h5>
              <p class="mb-0">
                {{integracao.ativa ? 'Esta loja está conectada e recebendo pedidos do aiqfome.' :
                'Esta loja está conectada ao aiqfome, mas o recebimento de pedidos está desativado.'}}
              </p>
            </div>
            <button type="button" class="btn btn-outline-secondary btn-sm" [disabled]="processando"
                    (click)="conectarAiqfome()">
              <i class="fas fa-sync-alt mr-2"></i>Reconectar conta
            </button>
            <small class="text-muted ml-2">Use somente se o acesso ao aiqfome for revogado ou parar de funcionar.</small>
          </ng-container>

          <ng-template #aguardandoConexaoAiqfome>
            <p>Habilite a integração no Geraldo e autorize com o ID Magalu do responsável pela loja.
              Ao retornar, cadastraremos o webhook e ativaremos o recebimento de pedidos.</p>
            <p>Aguardando autorização do lojista.</p>
            <button type="button" class="btn btn-primary btn-lg" [disabled]="processando"
                    (click)="conectarAiqfome()">
              Conectar com aiqfome
            </button>
          </ng-template>
        </ng-template>
      </div>
    </div>

    <ng-container *ngIf="!conexaoAiqfomePendente">
    <div class="card mb-4" *ngIf="integracao.modoConfiguracao !== 'aiqfome'">
      <div class="card-header bg-light">
        <h4 class="mb-0"><i class="fas fa-key mr-2"></i>Nossas Credenciais</h4>
        <small class="text-muted">Informações que devem ser configuradas no sistema do parceiro</small>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label>
                <i class="fas fa-id-card mr-1"></i>Merchant ID Promokit
                <small class="text-muted d-block">Identificador da loja enviado no onboarding</small>
              </label>
              <div class="input-group">
                <input kendoTextBox name="merchantIdPromokit" class="form-control"
                       readonly [value]="softwareService.merchantId || ''"/>
                <div class="input-group-append">
                  <button class="btn btn-outline-secondary" type="button"
                          [disabled]="!softwareService.merchantId"
                          (click)="copyMessage(softwareService.merchantId)"
                          [ngClass]="{'btn-success': textoCopiado === softwareService.merchantId}"
                          title="Copiar Merchant ID">
                    <i class="fe-copy" [ngClass]="{'text-white': textoCopiado === softwareService.merchantId}"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group">
              <label>
                <i class="fas fa-shield-alt mr-1"></i>API Key
                <small class="text-muted d-block">Chave utilizada pelo parceiro para consultar o Merchant</small>
              </label>
              <div class="input-group" *ngIf="apiKeyGerada">
                <input kendoTextBox name="apiKeyGerada" class="form-control"
                       readonly [value]="apiKeyGerada"/>
                <div class="input-group-append">
                  <button class="btn btn-outline-secondary" type="button"
                          (click)="copyMessage(apiKeyGerada)"
                          [ngClass]="{'btn-success': textoCopiado === apiKeyGerada}"
                          title="Copiar API Key">
                    <i class="fe-copy" [ngClass]="{'text-white': textoCopiado === apiKeyGerada}"></i>
                  </button>
                </div>
              </div>
              <div class="credencial-protegida" *ngIf="!apiKeyGerada">
                <i class="fas fa-lock mr-2"></i>
                {{integracao.id ? 'Chave protegida. Gere uma nova para visualizá-la.' : 'Será disponibilizada após salvar.'}}
              </div>
            </div>
          </div>
        </div>

        <div class="form-group">
          <label>
            <i class="fas fa-store mr-1"></i>URL Merchant
            <small class="text-muted d-block">Base pública para a plataforma consultar os dados da loja</small>
          </label>
          <div class="input-group">
            <input kendoTextBox name="urlMerchant" class="form-control" readonly [value]="urlMerchant"/>
            <div class="input-group-append">
              <button class="btn btn-outline-secondary" type="button" [disabled]="!urlMerchant"
                      (click)="copyMessage(urlMerchant)"
                      [ngClass]="{'btn-success': textoCopiado === urlMerchant}"
                      title="Copiar URL Merchant">
                <i class="fe-copy" [ngClass]="{'text-white': textoCopiado === urlMerchant}"></i>
              </button>
            </div>
          </div>
        </div>

        <button class="btn btn-outline-primary" type="button" *ngIf="!apiKeyGerada"
                [disabled]="processando" (click)="gerarCredenciais()">
          <i class="fas fa-sync-alt mr-2"></i>Gerar credenciais
          <i class="k-i-loading k-icon ml-2" *ngIf="processando"></i>
        </button>
      </div>
    </div>

    <div class="card mb-4">
      <div class="card-header bg-light">
        <h4 class="mb-0"><i class="fas fa-shield-alt mr-2"></i>{{integracao.modoConfiguracao === 'aiqfome' ? 'Configurações de pedidos' : 'Credenciais do Parceiro'}}</h4>
        <small class="text-muted">
          {{integracao.modoConfiguracao === 'aiqfome' ? 'Defina o comportamento dos pedidos recebidos do aiqfome' :
          'Configure a autenticação e a API da plataforma de pedidos'}}
        </small>
      </div>
      <div class="card-body">
        <div class="form-group" *ngIf="integracao.modoConfiguracao !== 'aiqfome'">
          <label>
            <i class="fas fa-building mr-1"></i>Nome da aplicação
            <small class="text-muted d-block">Até 12 letras ou números, sem espaços e sem acentos</small>
          </label>
          <input kendoTextBox name="nomeAplicacao" class="form-control"
                 #nomeAplicacao="ngModel" required maxlength="12" pattern="[a-z0-9]{1,12}"
                 [(ngModel)]="integracao.nomeAplicacao"
                 (ngModelChange)="normalizarNomeAplicacao($event)"
                 placeholder="Ex.: ifood, 99food, foodmaster, aiquefome"/>
          <div class="invalid-feedback" *ngIf="nomeAplicacao.errors?.required">Campo é obrigatório</div>
          <div class="invalid-feedback" *ngIf="nomeAplicacao.errors?.pattern">
            Use somente letras sem acentos e números.
          </div>
        </div>

        <div class="etapa-integracao mb-4" *ngIf="integracao.modoConfiguracao !== 'aiqfome'">
          <div class="etapa-cabecalho">
            <span class="etapa-numero">1</span>
            <div class="etapa-titulo">
              <h5>Autenticação</h5>
              <small>Escolha uma única forma para a Promokit acessar a API do parceiro</small>
            </div>
            <span class="etapa-tipo badge"
                  [ngClass]="modoAutenticacao === 'token-fixo' ? 'badge-warning' : 'badge-primary'">
              {{nomeModoAutenticacao}}
            </span>
          </div>

          <div class="etapa-conteudo">
            <div class="form-group">
              <label>
                <i class="fas fa-fingerprint mr-1"></i>App ID da plataforma
                <small class="text-muted d-block">Identifica o aplicativo no header X-App-Id e pode ser o mesmo para várias lojas.</small>
              </label>
              <input kendoTextBox name="appId" class="form-control"
                     #appId="ngModel" required [(ngModel)]="integracao.appId"
                     placeholder="App ID informado pela plataforma"/>
              <div class="invalid-feedback">Campo é obrigatório</div>
            </div>

            <div class="form-group mb-4">
              <label class="mb-2"><strong>Forma de autenticação</strong></label>
              <div class="opcoes-autenticacao">
                <label class="opcao-autenticacao"
                       [class.selecionada]="modoAutenticacao === 'credenciais-manuais'">
                  <input type="radio" name="modoAutenticacao" value="credenciais-manuais"
                         [checked]="modoAutenticacao === 'credenciais-manuais'"
                         [disabled]="processando"
                         (change)="alterarModoAutenticacao('credenciais-manuais')">
                  <span class="opcao-autenticacao-conteudo">
                    <span class="opcao-autenticacao-titulo">
                      <i class="fas fa-key mr-1"></i>Credenciais manuais
                      <span class="badge badge-primary ml-1">Padrão</span>
                    </span>
                    <small>
                      Use Client ID e Client Secret. A Promokit gera e renova o token automaticamente
                      pelo fluxo client_credentials.
                    </small>
                  </span>
                </label>

                <label class="opcao-autenticacao"
                       [class.selecionada]="modoAutenticacao === 'autorizacao-lojista'">
                  <input type="radio" name="modoAutenticacao" value="autorizacao-lojista"
                         [checked]="modoAutenticacao === 'autorizacao-lojista'"
                         [disabled]="processando"
                         (change)="alterarModoAutenticacao('autorizacao-lojista')">
                  <span class="opcao-autenticacao-conteudo">
                    <span class="opcao-autenticacao-titulo">
                      <i class="fas fa-user-check mr-1"></i>Autorização do lojista
                    </span>
                    <small>
                      O lojista entra no parceiro e autoriza esta loja. As credenciais da aplicação
                      são administradas pela Promokit.
                    </small>
                  </span>
                </label>

                <label class="opcao-autenticacao"
                       [class.selecionada]="modoAutenticacao === 'token-fixo'">
                  <input type="radio" name="modoAutenticacao" value="token-fixo"
                         [checked]="modoAutenticacao === 'token-fixo'"
                         [disabled]="processando"
                         (change)="alterarModoAutenticacao('token-fixo')">
                  <span class="opcao-autenticacao-conteudo">
                    <span class="opcao-autenticacao-titulo">
                      <i class="fas fa-lock mr-1"></i>Token fixo
                    </span>
                    <small>
                      Use quando o parceiro fornece diretamente um Bearer token. Não utiliza URL de
                      autenticação, Client ID ou Client Secret.
                    </small>
                  </span>
                </label>
              </div>
            </div>

            <ng-container *ngIf="modoAutenticacao === 'credenciais-manuais'">
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label><i class="fas fa-user mr-1"></i>Client ID</label>
                    <input kendoTextBox name="clientId" class="form-control"
                           #clientId="ngModel" required [(ngModel)]="integracao.clientId"
                           (ngModelChange)="autenticacaoAlterada()"
                           placeholder="Client ID para gerar o token"/>
                    <div class="invalid-feedback">Campo é obrigatório</div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label><i class="fas fa-key mr-1"></i>Client Secret</label>
                    <input kendoTextBox name="clientSecret" class="form-control" type="password"
                           #clientSecret="ngModel" [(ngModel)]="integracao.clientSecret"
                           (ngModelChange)="autenticacaoAlterada()"
                           [required]="!integracao.clientSecretConfigurado"
                           [placeholder]="integracao.clientSecretConfigurado ? 'Client Secret já configurado — deixe vazio para manter' : 'Client Secret'"/>
                    <div class="invalid-feedback">Campo é obrigatório</div>
                  </div>
                </div>
              </div>

              <div class="form-group mb-0">
                <label>
                  <i class="fas fa-lock mr-1"></i>URL de autenticação
                  <small class="text-muted d-block">Endpoint completo para obtenção e renovação do token</small>
                </label>
                <input kendoTextBox name="authUrl" class="form-control"
                       #authUrl="ngModel" required [(ngModel)]="integracao.authUrl"
                       (ngModelChange)="autenticacaoAlterada()"
                       placeholder="Ex.: https://parceiro.com/oauth/token"/>
                <div class="invalid-feedback">Campo é obrigatório</div>
              </div>

              <div class="d-flex align-items-center flex-wrap mt-3">
                <button class="btn btn-outline-primary" type="button"
                        [disabled]="processando || clientId.invalid || clientSecret.invalid || authUrl.invalid"
                        (click)="testarAutenticacao()">
                  <i class="fas fa-plug mr-2"></i>Testar credenciais
                  <i class="k-i-loading k-icon ml-2" *ngIf="processando"></i>
                </button>
                <small class="text-muted ml-3">Gera um token sem salvar as alterações.</small>
              </div>

              <div class="alert alert-success mt-3 mb-0" *ngIf="mensagemTesteAutenticacao" role="alert">
                <i class="fas fa-check-circle mr-2"></i>{{mensagemTesteAutenticacao}}
              </div>
              <div class="alert alert-danger mt-3 mb-0" *ngIf="erroTesteAutenticacao" role="alert">
                <i class="fas fa-exclamation-triangle mr-2"></i>{{erroTesteAutenticacao}}
              </div>
            </ng-container>

            <div class="autorizacao-lojista" *ngIf="modoAutenticacao === 'autorizacao-lojista'">
              <div class="autorizacao-lojista-cabecalho">
                <i class="fas fa-user-check"></i>
                <div>
                  <strong>Autorização do lojista</strong>
                  <small>
                    As credenciais e os endereços de autenticação são administrados pela Promokit.
                    O lojista precisa apenas autorizar o acesso à loja.
                  </small>
                </div>
              </div>

              <div class="alert mb-3"
                   [ngClass]="integracao.oauthAutorizado ? 'alert-success' : 'alert-light border'">
                <i class="fas mr-2"
                   [ngClass]="integracao.oauthAutorizado ? 'fa-check-circle' : 'fa-info-circle'"></i>
                {{integracao.oauthAutorizado ? 'Parceiro autorizado. Os tokens serão renovados automaticamente.' :
                'Salve a configuração e depois autorize usando a conta do lojista.'}}
              </div>
              <button type="button" class="btn btn-primary" (click)="autorizarParceiro()"
                      [disabled]="processando || !integracao.id || frm.dirty">
                <i class="fas fa-external-link-alt mr-2"></i>
                {{integracao.oauthAutorizado ? 'Autorizar novamente' : 'Autorizar parceiro'}}
              </button>
            </div>

            <div class="form-group mb-0" *ngIf="integracao.usarTokenFixo">
              <label>
                <i class="fas fa-key mr-1"></i>Token fixo
                <small class="text-muted d-block">Será enviado diretamente no header Authorization: Bearer</small>
              </label>
              <input kendoTextBox name="tokenFixo" class="form-control" type="password"
                     #tokenFixo="ngModel" [(ngModel)]="integracao.tokenFixo"
                     [required]="!integracao.tokenFixoConfigurado"
                     [placeholder]="integracao.tokenFixoConfigurado ? 'Token já configurado — deixe vazio para manter' : 'Bearer token fornecido pela plataforma'"/>
              <div class="invalid-feedback">Campo é obrigatório</div>
            </div>
          </div>
        </div>

        <div class="etapa-integracao">
          <div class="etapa-cabecalho" [class.etapa-sem-numero]="integracao.modoConfiguracao === 'aiqfome'">
            <span class="etapa-numero" *ngIf="integracao.modoConfiguracao !== 'aiqfome'">2</span>
            <div class="etapa-titulo">
              <h5>Pedidos</h5>
              <small>{{integracao.modoConfiguracao === 'aiqfome' ?
                'Configure como esta loja deve tratar os pedidos recebidos' :
                'Informe onde buscar e atualizar os pedidos desta loja'}}</small>
            </div>
          </div>

          <div class="etapa-conteudo">
            <div class="form-group mb-4" *ngIf="urlWebhookOnboarding">
              <label for="urlWebhookOnboarding">
                <i class="fas fa-bell mr-1"></i>URL do webhook no parceiro
                <small class="text-muted d-block">
                  Edite a URL e clique em Atualizar no parceiro para enviar um novo onboarding
                </small>
              </label>
              <div class="input-group">
                <input kendoTextBox id="urlWebhookOnboarding" name="urlWebhookOnboarding"
                       class="form-control" type="url" required [(ngModel)]="urlWebhookEdicao"
                       [ngModelOptions]="{standalone: true}"
                       placeholder="https://dominio.exemplo.com/opendelivery/ss/v1/newEvent"/>
                <div class="input-group-append">
                  <button class="btn btn-outline-primary" type="button" [disabled]="processando"
                          (click)="atualizarWebhook()" title="Reenviar esta URL no onboarding do parceiro">
                    <i class="fas fa-sync-alt mr-1"></i>Atualizar no parceiro
                    <i class="k-i-loading k-icon ml-1" *ngIf="operacaoEmExecucao === 'webhook'"></i>
                  </button>
                  <button class="btn btn-outline-secondary" type="button"
                          (click)="copyMessage(urlWebhookEdicao)"
                          [ngClass]="{'btn-success': textoCopiado === urlWebhookEdicao}"
                          title="Copiar URL do webhook">
                    <i class="fe-copy" [ngClass]="{'text-white': textoCopiado === urlWebhookEdicao}"></i>
                  </button>
                </div>
              </div>
              <small class="text-muted d-block mt-2">
                Reenvia o onboarding com a URL atual. A autorização do lojista não será solicitada novamente.
              </small>
              <div class="alert alert-success mt-2 mb-0" *ngIf="mensagemWebhook" role="status">
                <i class="fas fa-check-circle mr-2"></i>{{mensagemWebhook}}
              </div>
              <div class="alert alert-danger mt-2 mb-0" *ngIf="erroWebhook" role="alert">
                <i class="fas fa-exclamation-triangle mr-2"></i>{{erroWebhook}}
              </div>
            </div>

            <div class="custom-control custom-switch mb-4">
              <input type="checkbox" class="custom-control-input" id="opendeliverySempreConfirmarPedidos"
                     name="sempreConfirmarPedidos" [(ngModel)]="integracao.sempreConfirmarPedidos" [disabled]="processando">
              <label class="custom-control-label" for="opendeliverySempreConfirmarPedidos">
                <strong>Sempre confirmar pedidos desse parceiro</strong>
                <small class="text-muted d-block">
                  Quando marcado, todos os pedidos recebidos desse parceiro são aceitos automaticamente,
                  mesmo com a loja fora do horário, pausada ou com o aceite automático geral desligado.
                  Nenhum pedido será rejeitado automaticamente por essas condições.
                </small>
              </label>
            </div>
            <div class="form-group" *ngIf="integracao.modoConfiguracao !== 'aiqfome'">
              <label>
                <i class="fas fa-globe mr-1"></i>URL Base API
                <small class="text-muted d-block">Base dos endpoints OpenDelivery da plataforma</small>
              </label>
              <input kendoTextBox name="baseUrl" class="form-control"
                     #baseUrl="ngModel" required [(ngModel)]="integracao.baseUrl"
                     placeholder="Ex.: https://plataforma.exemplo.com/api/od/v1"/>
              <div class="invalid-feedback">Campo é obrigatório</div>
            </div>

            <ng-container *ngIf="urlWebhookOnboarding; else opcaoPolling">
              <div class="alert alert-info mb-3" role="status">
                <i class="fas fa-check-circle mr-2"></i>
                O recebimento por webhook está ativo. O polling automático permanece desativado para evitar pedidos duplicados.
              </div>
              <button class="btn btn-outline-warning mb-3" type="button"
                      *ngIf="!confirmandoTrocaParaPolling" [disabled]="processando"
                      (click)="soliciteTrocaParaPolling()">
                <i class="fas fa-exchange-alt mr-2"></i>Trocar webhook por polling
              </button>
              <div class="alert alert-warning" *ngIf="confirmandoTrocaParaPolling" role="alert">
                <strong class="d-block mb-2">Esta troca removerá o webhook cadastrado no parceiro.</strong>
                <p>
                  Será enviado um novo onboarding sem URL de webhook. Depois disso, os pedidos serão buscados
                  somente pelo polling automático.
                </p>
                <button class="btn btn-warning font-weight-bold" type="button" [disabled]="processando"
                        (click)="ativePollingRemovendoWebhook()">
                  Confirmar troca para polling
                  <i class="k-i-loading k-icon ml-2" *ngIf="processando"></i>
                </button>
                <button class="btn btn-link" type="button" [disabled]="processando"
                        (click)="canceleTrocaParaPolling()">Manter webhook</button>
              </div>
            </ng-container>

            <ng-template #opcaoPolling>
              <div class="custom-control custom-switch mb-3">
                <input type="checkbox" class="custom-control-input" id="opendeliveryPollingAtivo"
                       name="pollingAtivo" [(ngModel)]="integracao.pollingAtivo" [disabled]="processando">
                <label class="custom-control-label" for="opendeliveryPollingAtivo">
                  <strong>Ativar polling automático</strong>
                </label>
              </div>
            </ng-template>

            <div class="alert alert-success" *ngIf="mensagemTrocaRecebimento" role="status">
              <i class="fas fa-check-circle mr-2"></i>{{mensagemTrocaRecebimento}}
            </div>
            <div class="alert alert-danger" *ngIf="erroTrocaRecebimento" role="alert">
              <i class="fas fa-exclamation-triangle mr-2"></i>{{erroTrocaRecebimento}}
            </div>
            <div class="alert alert-warning" *ngIf="integracao.pollingAtivo" role="alert">
              Recomenda-se ativar somente quando o parceiro não tiver suporte a webhook.
            </div>

            <ng-container *ngIf="integracao.pollingAtivo">
              <div class="row mb-3">
                <div class="col-md-6">
                  <span class="text-muted d-block">Última consulta</span>
                  <strong>{{integracao.ultimaConsulta ? (integracao.ultimaConsulta | date:'dd/MM/yyyy HH:mm:ss') : 'Ainda não realizada'}}</strong>
                </div>
                <div class="col-md-6" *ngIf="integracao.ultimoErro">
                  <span class="text-danger d-block">Último erro</span>
                  <strong class="text-danger">{{integracao.ultimoErro}}</strong>
                </div>
              </div>

              <button class="btn btn-outline-secondary" type="button"
                      [disabled]="processando || !integracao.id" (click)="testarPolling()">
                <i class="fas fa-sync mr-2"></i>Testar polling
                <i class="k-i-loading k-icon ml-2" *ngIf="operacaoEmExecucao === 'polling'"></i>
              </button>
              <small class="text-muted ml-3">Apenas verifica a leitura dos eventos, sem salvar notificações, importar pedidos ou confirmar leitura.</small>

              <div class="alert alert-success mt-3 mb-0"
                   *ngIf="ultimaOperacao === 'polling' && mensagemOperacao" role="alert">
                <i class="fas fa-check-circle mr-2"></i>{{mensagemOperacao}}
              </div>
              <div class="alert alert-danger mt-3 mb-0"
                   *ngIf="ultimaOperacao === 'polling' && erroOperacao" role="alert">
                <i class="fas fa-exclamation-triangle mr-2"></i>{{erroOperacao}}
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>

    <div class="card mb-4" *ngIf="integracao.modoConfiguracao !== 'aiqfome'">
      <div class="card-header bg-light">
        <h4 class="mb-0"><i class="fas fa-paper-plane mr-2"></i>Operação Onboarding</h4>
        <small class="text-muted">Cadastre esta loja na plataforma OpenDelivery</small>
      </div>
      <div class="card-body">
        <div class="alert alert-info">
          <i class="fas fa-info-circle mr-2"></i>
          Envia ao parceiro o Merchant ID, a URL do webhook de pedidos e a URL Merchant com sua API Key.
          Execute após salvar a configuração para registrar esta loja na plataforma.
        </div>

        <button class="btn btn-outline-primary" type="button"
                [disabled]="processando || !integracao.id" (click)="onboarding()">
          <i class="fas fa-paper-plane mr-2"></i>Enviar onboarding
          <i class="k-i-loading k-icon ml-2" *ngIf="operacaoEmExecucao === 'onboarding'"></i>
        </button>

        <div class="alert alert-success mt-3 mb-0"
             *ngIf="ultimaOperacao === 'onboarding' && mensagemOperacao" role="alert">
          <i class="fas fa-check-circle mr-2"></i>{{mensagemOperacao}}
        </div>
        <div class="alert alert-danger mt-3 mb-0"
             *ngIf="ultimaOperacao === 'onboarding' && erroOperacao" role="alert">
          <i class="fas fa-exclamation-triangle mr-2"></i>{{erroOperacao}}
        </div>
      </div>
    </div>

    <div class="card-footer bg-light text-right">
      <div class="alert alert-warning aviso-integracao-inativa text-left mb-3"
           *ngIf="!integracao.ativa" role="alert">
        <h5 class="font-weight-bold mb-2">
          <i class="fas fa-exclamation-triangle mr-2"></i>Integração INATIVA
        </h5>
        <p class="mb-3">
          Esta loja não está recebendo pedidos por esta integração. Salvar a configuração não ativa o recebimento.
          <strong>Os pedidos só serão recebidos após ativar a integração.</strong>
        </p>
        <button class="btn btn-success btn-lg font-weight-bold" type="button"
                [disabled]="processando" *ngIf="integracao.id" (click)="alterarAtivacao(true)">
          <i class="fas fa-power-off mr-2"></i>Ativar integração e receber pedidos
        </button>
        <strong class="d-block" *ngIf="!integracao.id">{{integracao.modoConfiguracao === 'aiqfome' ? 'Use Conectar com aiqfome para autorizar e ativar a integração.' : 'Salve a configuração para liberar o botão de ativação.'}}</strong>
        <div class="alert alert-danger mt-3 mb-0" *ngIf="erroAtivacao" role="alert">
          <i class="fas fa-exclamation-triangle mr-2"></i>{{erroAtivacao}}
        </div>
      </div>

      <span class="text-success mr-3" *ngIf="mensagemSalvar">
        <i class="fas fa-check-circle mr-1"></i>{{mensagemSalvar}}
      </span>
      <span class="text-danger mr-3" *ngIf="erroSalvar">
        <i class="fas fa-exclamation-triangle mr-1"></i>{{erroSalvar}}
      </span>

      <button class="btn btn-success" type="submit" [disabled]="processando">
        <i class="fas fa-save mr-2"></i>Salvar
        <i class="k-i-loading k-icon ml-2" *ngIf="processando"></i>
      </button>

      <button class="btn btn-danger ml-2" type="button" [disabled]="processando"
              *ngIf="integracao.id && integracao.ativa" (click)="alterarAtivacao(false)">
        <i class="fas fa-power-off mr-2"></i>Desativar
      </button>
    </div>
    </ng-container>
  </form>
  </ng-container>
</section>
